/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { TabDelivery, TabPdtInfo, TabTariff, TabRelated } from "./TabContent";
import { Translation } from "react-i18next";
import Swiper from "swiper";

let $ = window.$;

const tabList = [
  {
    name: "productDetails",
    id: "tabContent_pdtInfo",
    default: true
  },
  {
    name: "shipping&Return",
    id: "tabContent_delivery"
  },
  {
    name: "duties&Taxes",
    id: "tabContent_tariff"
  }
];

class Tab extends React.Component {
  componentDidMount() {
    new Swiper(".tab_wrap .swiper-container-tab", {
      slidesPerView: "auto",
      grabCursor: true,
      freeMode: true,
      noSwiping: true,
      allowTouchMove: false,
      breakpoints: {
        991: {
          noSwiping: false,
          allowTouchMove: true
        }
      }
    });
    $(document).on("click", ".tabLinks", function() {
      $(".tabContent").removeClass("active");
      $(".tabLinks").removeClass("active");

      var selector = $(this).attr("data-target");

      $(selector).addClass("active");
      $(this).addClass("active");
    });
  }
  render() {
    const { info, matchingPdt } = this.props;
    return (
      <div className="tab_wrap d-none d-md-block">
        <div className="swiper-container swiper-container-tab">
          <div className="swiper-wrapper">
            {tabList.map((tab, index) => (
              <div key={tab.name} className="swiper-slide">
                <button
                  className={(tab.default && "tabLinks active") || "tabLinks"}
                  data-target={`#${tab.id}`}
                >
                  <Translation>
                    {t => <>{t(`tabListIndex.${tab.name}`)}</>}
                  </Translation>
                </button>
              </div>
            ))}
            {/* {details.collection.code === "C287"
              ? tabListWithCodeC287.map((tab, index) => (
                  <div key={tab.name} className="swiper-slide">
                    <button
                      className={
                        (tab.default && "tabLinks active") || "tabLinks"
                      }
                      data-target={`#${tab.id}`}
                      key={index}
                    >
                      <Translation>
                        {t => <>{t(`tabListIndex.${tab.name}`)}</>}
                      </Translation>
                    </button>
                  </div>
                ))
              : tabList.map((tab, index) => (
                  <div key={tab.name} className="swiper-slide">
                    <button
                      className={
                        (tab.default && "tabLinks active") || "tabLinks"
                      }
                      data-target={`#${tab.id}`}
                      key={index}
                    >
                      <Translation>
                        {t => <>{t(`tabListIndex.${tab.name}`)}</>}
                      </Translation>
                    </button>
                  </div>
                ))} */}
          </div>
        </div>

        <div className="tabDividor" />
        <div className="tabContents_wrap" id="tabContents_wrap">
          {/* <div id="tabContent_collectionIntro" className="tabContent noPadding">
            <TabCollectionIntro />
          </div> */}
          <div id="tabContent_pdtInfo" className="tabContent  active">
            {(info !== undefined && <TabPdtInfo info={info} />) || null}
          </div>
          <div id="tabContent_delivery" className="tabContent">
            <TabDelivery />
          </div>
          <div id="tabContent_tariff" className="tabContent">
            <TabTariff />
          </div>
          <div id="tabContent_related" className="tabContent">
            {(matchingPdt !== undefined && (
              <TabRelated matchingPdt={matchingPdt} />
            )) ||
              null}
          </div>
        </div>
      </div>
    );
  }
}

export default Tab;
